/* eslint-disable no-console */
import React from "react";
import { PropTypes } from "prop-types";
import { Logo } from "@bca/ui-library";
import { StyledFooter, StyledFooterText, StyledImg } from "./Footer.styled";
import RGB_BCA_SVG from "../../images/RGB_BCA_AUTOENCHERES.svg";

const Footer = ({ isMobile, footerText, countrySelected }) => {
  return (
    <StyledFooter isMobile={isMobile}>
      {countrySelected === "FR" ? (
        <StyledImg src={RGB_BCA_SVG} alt="BCA Logo" isMobile={isMobile} />
      ) : (
        <Logo />
      )}
      <StyledFooterText isMobile={isMobile}>{footerText}</StyledFooterText>
    </StyledFooter>
  );
};

Footer.propTypes = {
  isMobile: PropTypes.bool,
  footerText: PropTypes.string,
  countrySelected: PropTypes.string,
};

Footer.defaultProps = {
  isMobile: false,
  footerText: "",
  countrySelected: "",
};

export default Footer;
